import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { defaultSuccess } from "../../../libs/utils";
import ListView from "../../../base/ListView";
import { toImmutable } from "../../../libs/immutable-transformer";
import { getDevices } from "../../../services/api/devices";
import ProgressBar from "../../../base/ProgressBar";
import ModalToBody from "../../../base/ModalToBody";

class Devices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      devices: [],
      devicesMeta: {},
      devicesFilters: toImmutable({}),
      showModal: false,
      location: undefined
    };

    this._getDevices = this._getDevices.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
  }

  _closeModal() {
    this.setState({ showModal: false });
  }

  _openModal(location) {
    this.setState({
      showModal: true,
      location
    });
  }

  static propTypes = {
    prop: PropTypes.string
  };

  UNSAFE_componentWillMount() {
    this._getDevices();
  }

  _handleFilterUpdate(filter) {
    this._getDevices(filter);
  }

  _getDevices(filters = this.state.devicesFilters, notify = false) {
    getDevices(filters).then(response => {
      this.setState({
        devices: response.data,
        devicesMeta: response.meta,
        devicesFilters: filters
      });

      if (notify) {
        defaultSuccess("Reloaded");
      }
    });
  }

  render() {
    const {
      devices,
      devicesMeta,
      devicesFilters,
      location,
      showModal
    } = this.state;

    const listViewConf = {
      dataSet: devices,
      dataMeta: devicesMeta,
      columns: [
        {
          key: "name",
          value: "name"
        },
        {
          key: "status",
          value: "Status"
        },
        {
          key: "battery",
          value: "Battery",
          render: device => <ProgressBar percent={device.battery} />
        }
      ],
      baseFilters: devicesFilters,
      filters: [],
      actions: {
        deleteLink: false,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: device => {
          if (device.usage && device.usage !== "") {
            return (
              <div className="text-right">
                <button
                  className="btn btn-outline-accent m-btn btn-sm  m-btn--icon m--margin-left-5"
                  onClick={() => this._openModal(device.usage)}
                >
                  <span>
                    <i className="la la-map-marker" />
                    <span>Show Location</span>
                  </span>
                </button>
              </div>
            );
          }

          return null;
        }
      },
      url: "/admin/devices"
    };

    return (
      <div>
        <AdminSubHeader title="Devices">
          <button
            onClick={() => this._getJobs(undefined, true)}
            className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
          >
            <i className="la la-refresh" />
          </button>
        </AdminSubHeader>
        <div className="m-content" key="content">
          <div className="row">
            <div className="col-lg-12">
              <ListView
                config={listViewConf}
                handleFilterUpdate={this._handleFilterUpdate}
              />
            </div>
          </div>
        </div>
        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1039"
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Request Parking
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                {showModal && location && (
                  <iframe
                    title="map"
                    src={`https://maps.google.com/maps?q=${location}&z=18&output=embed`}
                    width="500"
                    height="270"
                    frameBorder="0"
                    style={{
                      width: "100%"
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          <div
            className={"modal-backdrop fade " + (showModal ? " show" : "")}
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1038"
            }}
          />
        </ModalToBody>
      </div>
    );
  }
}

export default Devices;
